(function () {
  function getManualOffset(article) {
    var parsed = parseInt(article.dataset.stickyOffset || '', 10);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function getBottomGap(article) {
    var parsed = parseInt(article.dataset.sidebarBottomGap || '', 10);
    return Number.isFinite(parsed) ? parsed : 16;
  }

  function getSiteHeaderBottom() {
    var header = document.querySelector('.section-header');
    if (header && header.classList.contains('shopify-section-header-hidden')) {
      var announcement = document.querySelector('.announcement-bar-section');
      if (announcement) {
        var announcementRect = announcement.getBoundingClientRect();
        if (announcementRect.height > 0 && announcementRect.bottom > 0) {
          return announcementRect.bottom;
        }
      }
      return 0;
    }

    var measured = 0;

    document
      .querySelectorAll(
        '.announcement-bar-section, .utility-bar, .section-header, sticky-header'
      )
      .forEach(function (node) {
        var rect = node.getBoundingClientRect();
        if (rect.height > 0 && rect.bottom > 0) {
          measured = Math.max(measured, rect.bottom);
        }
      });

    return measured;
  }

  function getSiteFooterTop() {
    var footer = document.querySelector(
      'footer.tamitami-footer, .shopify-section-group-footer-group footer, .shopify-section-group-footer-group'
    );
    if (!footer) return null;

    var rect = footer.getBoundingClientRect();
    if (rect.height <= 0) return null;

    return rect.top;
  }

  function getHeaderOffset(article) {
    var manual = getManualOffset(article);
    var measured = getSiteHeaderBottom();
    return Math.max(measured, manual, 24) + 16;
  }

  function syncSidebarLayout(article) {
    if (!article) return;

    var bottomGap = getBottomGap(article);
    var headerOffset = getHeaderOffset(article);

    article.style.setProperty('--tt-blog-sidebar-top', headerOffset + 'px');
    article.style.setProperty('--tt-blog-sidebar-bottom-gap', bottomGap + 'px');

    var footerTop = getSiteFooterTop();
    if (footerTop == null) {
      article.style.removeProperty('--tt-blog-sidebar-bottom-limit');
      return;
    }

    article.style.setProperty(
      '--tt-blog-sidebar-bottom-limit',
      Math.max(footerTop - bottomGap, headerOffset + 1) + 'px'
    );
  }

  function syncAllSidebars() {
    document.querySelectorAll('[data-blog-article]').forEach(syncSidebarLayout);
  }

  function clearHeaderWidthLock() {
    var main = document.querySelector('main[data-template="article"]');
    [document.documentElement, main].forEach(function (node) {
      if (!node) return;
      node.style.removeProperty('--tt-blog-layout-content-width');
      node.style.removeProperty('--tt-blog-container-width');
      node.style.removeProperty('--tt-blog-layout-padding-left');
      node.style.removeProperty('--tt-blog-layout-padding-right');
    });
  }

  function onLayoutChange() {
    clearHeaderWidthLock();
    syncAllSidebars();
  }

  var ticking = false;

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      syncAllSidebars();
      ticking = false;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    onLayoutChange();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onLayoutChange, { passive: true });
  });

  document.addEventListener('shopify:section:load', onLayoutChange);

  document.addEventListener('tt-blog:after-jump', function () {
    window.requestAnimationFrame(onLayoutChange);
  });
})();
